import { FC } from 'react';

import {
    AlertCircle,
    AlertTriangle,
    CheckCircle2,
    Clock3,
    Loader2,
    Pencil,
    SearchX,
} from 'lucide-react';

import { OfferDraft } from '../../../../types';

interface Props {
    offer: OfferDraft;
    autoPriceEnabled: boolean;
    ready: boolean;
}

export const autoPriceStatusText = (
    offer: OfferDraft,
    autoPriceEnabled: boolean,
) => {
    switch (offer.auto_price_status) {
        case 'pending':
            return 'У черзі на розрахунок автоціни';
        case 'loading':
            return 'Шукаємо ринкову ціну…';
        case 'priced':
            return 'Автоціну розраховано';
        case 'manual':
            return autoPriceEnabled
                ? 'Ціну змінено вручну — автоціна її не перезапише'
                : null;
        case 'unavailable':
            return `Автоціну не знайдено${offer.auto_price_error ? `: ${offer.auto_price_error}` : ''}`;
        case 'error':
            return `Помилка автоціни${offer.auto_price_error ? `: ${offer.auto_price_error}` : ''}`;
        default:
            return offer.auto_price_error;
    }
};

export const BulkOfferAutoPriceStatus: FC<Props> = ({
    offer,
    autoPriceEnabled,
    ready,
}) => {
    const iconClassName = 'mt-0.5 h-3.5 w-3.5 shrink-0';

    switch (offer.auto_price_status) {
        case 'pending':
            return (
                <Clock3
                    className={`${iconClassName} text-blue-500`}
                    aria-label="У черзі на автоціну"
                />
            );
        case 'loading':
            return (
                <Loader2
                    className={`${iconClassName} animate-spin text-blue-500`}
                    aria-label="Пошук автоціни"
                />
            );
        case 'priced':
            return (
                <CheckCircle2
                    className={`${iconClassName} text-emerald-600`}
                    aria-label="Автоціну розраховано"
                />
            );
        case 'manual':
            return autoPriceEnabled ? (
                <Pencil
                    className={`${iconClassName} text-muted-foreground`}
                    aria-label="Ціну змінено вручну"
                />
            ) : null;
        case 'unavailable':
            return (
                <SearchX
                    className={`${iconClassName} text-amber-600`}
                    aria-label="Автоціну не знайдено"
                />
            );
        case 'error':
            return (
                <AlertCircle
                    className={`${iconClassName} text-destructive`}
                    aria-label="Помилка автоціни"
                />
            );
        default:
            return ready ? null : (
                <AlertTriangle
                    className={`${iconClassName} text-destructive`}
                    aria-label="Потрібно заповнити"
                />
            );
    }
};
